// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__12LA0","row":"styles_row__ByvVz"};